module.exports = __webpack_public_path__ + "static/media/photo162.978be2aa.jpg";